import apiClient, { API_ENDPOINTS, dispatchAndResolve, rejectWithError } from "api";
import * as types from "./types.jsx";

const { reservation } = API_ENDPOINTS;

export const getReservationSlots = (reservationPayload) => async (dispatch) => {
  try {
    const data = await apiClient.post(reservation.getSlots, reservationPayload);
    return dispatchAndResolve(dispatch, types.GET_RESERVATION_SLOTS_SUCCESS, data);
  } catch (error) {
    dispatch({ type: types.GET_RESERVATION_SLOTS_FAIL, payload: error?.payload || error });
    return rejectWithError(error, "Get Reservation Slots Error");
  }
};
